import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { acquisitionChannelKeys } from '@/lib/queryKeys';
import { acquisitionChannelEndpoints } from '@/lib/api/endpoints';
import { apiPost, operationsClient } from '@/lib/api';
import type { AcquisitionChannel, CreateAcquisitionChannelDto } from '@/types/acquisitionChannel';

export function useCreateAcquisitionChannel() {
  const queryClient = useQueryClient();

  return useApiMutation<AcquisitionChannel, CreateAcquisitionChannelDto>({
    mutationFn: (dto) =>
      apiPost<AcquisitionChannel, CreateAcquisitionChannelDto>(
        operationsClient,
        acquisitionChannelEndpoints.list(),
        dto,
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: acquisitionChannelKeys.all(),
      });
      toast.success('Channel created');
    },
    // The 409 for a similar name is a question, not a failure: the section
    // catches it and offers to confirm. A toast here would talk over that.
    showErrorToast: false,
  });
}
